import { gql } from "@apollo/client";
import type { TeamItemFragment } from "src/gql/codegen/graphql";

export const teamItemGqlFragment = gql`
  fragment TeamItem on teams {
    id
    name
    handle
    profile_image_url

    created_at
    received_stars {
      sum
    }

    members: memberships(where: { user_id: { _is_null: false } }) {
      user {
        id
        name
        profile_image_url
      }
    }
  }
`;

export interface TeamType {
  id: number;
  handle: string;
  name: string;
  profile_image_url?: string;

  created_at: string;
  receivedStars: number;

  members: Array<{
    id: number;
    name: string;
    profile_image_url: string;
  }>;
}

/* Selector: Transform team result fragment to more usable data structure */
export function toTeamType(team: TeamItemFragment): TeamType {
  return {
    id: team.id,
    handle: team.handle,
    name: team.name,
    profile_image_url: team.profile_image_url ?? undefined,

    created_at: team.created_at,
    receivedStars: team.received_stars?.sum ?? 0,

    members: team.members.reduce<TeamType["members"][number][]>(
      (final, current) => {
        if (current.user === null || current.user === undefined) return final;
        return final.concat([
          {
            id: current.user.id,
            name: current.user.name,
            profile_image_url: current.user.profile_image_url ?? "",
          },
        ]);
      },
      []
    ),
  };
}
